import React from 'react'
import { SkeletonAvatarProps } from './Skeleton.types'
import { StyledBox } from './styled'

const Avatar: React.FC<SkeletonAvatarProps> = ({ color, size = '36px', ...props }) => {
  return (
    <StyledBox height={size} width={size} backgroundColor={color} borderRadius='50%' {...props} />
  )
}

export default Avatar
